import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { AllSecondaryCollectionTransaction } from "../../../Apis/TransferStationReport/secondaryCollectionTransactionApi";
import TableComponent from "../../../Common/TableComponent/tableComponent";
import ExcelJS from "exceljs";
import isGHMC, { getCurrentDateTime1 } from "../../../Common/helper/helpar";
import { GetZone } from "../../../Apis/organizationApi";
import Loader from "../../../Common/Loader/loader";
import { getNowDateTime, getOneMonthPastDateTime } from "../../AssetVehicle/utils/helpers";
import TableSkeleton from "../../AllotedMaster/TableSkeleton";

const SecondaryCollectionTransaction = ({ t }) => {
  const headers = [
    // "vehicleUid",
    "vehicleNumber",
    "corporation",
    "category",
    "zone",
    "circle",
    "ward",
    "vehicleType",
    "ownerType",
    "shift",
    "driverName",
    "beforeDateTime",
    "afterDateTime",
    "collectionPointCode",
    "collectionPointName",
    "collectionPointType",
    "beforeLatitude",
    "afterLatitude",
    "beforeLongitude",
    "afterLongitude",
    //"beforeAddress",
   // "afterAddress",
    "beforeImage",
    "afterImage",
  ];

  const [getAllTripsTonnage, setAllTripsTonnage] = useState([]);
  const [startDate, setStartDate] = useState(getStartOfCurrentDate());
  const [endDate, setEndDate] = useState(getCurrentDateTime());
  const [vehicleNumber, setVehicleNumber] = useState("");
  const [allZones, setAllZones] = useState("");
  const [zoneId, setZoneId] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [collectionPointName, setCollectionPointName] = useState("");
  const isProd = isGHMC();

  const fetchAllZoneData = async () => {
    try {
      const zonesData = await GetZone();
      setAllZones(zonesData);
    } catch (error) {
      console.error("Error fetching initial data:", error);
    }
  };

  useEffect(() => {
    fetchAllZoneData();
    fetchTripsTonnageData(startDate, endDate, zoneId, vehicleNumber, collectionPointName);
  }, []);

  const fetchTripsTonnageData = async (startDate, endDate, zoneId, vehicleNumber, collectionPointName) => {
    setIsLoading(true);
    try {
      const response = await AllSecondaryCollectionTransaction(startDate, endDate, zoneId, vehicleNumber, collectionPointName);
      const formattedData = response.data.map((item) => ({
        ...item,
        vehicleUid: item.vehicleUuid || "N/A",
        beforeImage: item.beforeImageUrl || "N/A",
        afterImage: item.afterImageUrl || "N/A",
        beforeLatitude: item.beforeLatitude || "N/A",
        beforeLongitude: item.beforeLongitude || "N/A",
        afterLatitude: item.afterLatitude || "N/A",
        afterLongitude: item.afterLongitude || "N/A",
        beforeDateTime: item.beforeDateTime || "N/A",
        afterDateTime: item.afterDateTime || "N/A",
        collectionPointType: item.collectionPointType || "N/A",
        collectionPointName: item.collectionPointName || "N/A",
        collectionPointCode: item.collectionPointCode || "N/A",
        zone: item.zoneName || "N/A",
        circle: item.circleName || "N/A",
        ward: item.wardName || "N/A",
        shift: item.shiftName || "N/A",
        vehicleType: item.vehicleTypeName || "N/A",
        ownerType: item.ownerTypeName || "N/A",
        corporation: item.corporationName || "N/A",
        category: item.categoryName || "N/A",
      //  beforeAddress: item.beforeAddress || "N/A",
       // afterAddress: item.afterAddress || "N/A",
      }));
      setAllTripsTonnage(formattedData);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    fetchTripsTonnageData(startDate, endDate, zoneId, vehicleNumber, collectionPointName);
  };

  // Function to format dates for display
  const formatDateForDisplay = (dateString) => {
    const date = new Date(dateString);
    const options = { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" };
    return date.toLocaleString("en-GB", options).replace(",", "");
  };

  const options = { day: "numeric", month: "numeric", year: "numeric" };
  const generationTime = ` ${new Date().toLocaleString("en-GB", options).replace(/\//g, "/")}`;
  const downloadAsExcel = async () => {
    const currentDate = new Date();
    const formattedDate = `${currentDate.getDate()}-${currentDate.getMonth() + 1}-${currentDate.getFullYear()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const cumulativeHeadingReport = `Secondary Collection Transaction Reports ${formatDateForDisplay(startDate)} to ${formatDateForDisplay(endDate)} (at ${getCurrentDateTime1()})`;
    const downloadDateTime = `Report Generated on: ${generationTime}, ${formattedTime}`;
    const dateRange = `Date Range: ${formatDateForDisplay(startDate)} to ${formatDateForDisplay(endDate)}`;

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Zones");
    const boldFont = { bold: true };

    // Add Report Generation Date
    worksheet.addRow(["", "", downloadDateTime, ""]);
    worksheet.mergeCells(1, 2, 1, 13);
    worksheet.getCell(1, 2).value = downloadDateTime;
    worksheet.getCell(1, 2).font = boldFont;
    worksheet.getCell(1, 2).alignment = { horizontal: "center" };

    for (let col = 2; col <= 13; col++) {
      worksheet.getCell(1, col).font = boldFont;
      worksheet.getCell(1, col).alignment = { horizontal: "center" };
    }

    for (let col = 2; col <= 13; col++) {
      worksheet.getCell(2, col).font = boldFont;
      worksheet.getCell(2, col).alignment = { horizontal: "center" };
    }

    // Add Report Title
    worksheet.addRow(["", "", cumulativeHeadingReport, ""]);
    worksheet.mergeCells(3, 2, 3, 13);
    worksheet.getCell(3, 2).value = cumulativeHeadingReport;
    worksheet.getCell(3, 2).font = boldFont;
    worksheet.getCell(3, 2).alignment = { horizontal: "center" };

    for (let col = 2; col <= 13; col++) {
      worksheet.getCell(3, col).font = boldFont;
      worksheet.getCell(3, col).alignment = { horizontal: "center" };
    }

    // Add empty row for spacing
    worksheet.addRow([""]);

    // Add table header row with bold font
    const tableHeaderRow = worksheet.addRow([
      "S.No",
      // "Vehicle UID",
      "Vehicle Number",
      "corporation",
      "category",
      "Zone",
      "Circle",
      "Ward",
      "Vehicle Type",
      "Owner Type",
      "Shift",
      "Driver Name",
      "Before Date Time",
      "After Date Time",
      "Collection Point Code",
      "Collection Point Name",
      "Collection Point Type",
      "Before Latitude",
      "After Latitude",
      "Before Longitude",
      "After Longitude",
    //  "Before Address",
     // "After Address",
    ]);

    tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      cell.font = boldFont;
      cell.alignment = { horizontal: "left" };
      if (colNumber >= 1 && colNumber <= 25) {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "F6B1B1" },
        };
      }
    });

    // Add data rows
    getAllTripsTonnage.forEach((item, index) => {
      worksheet.addRow([
        index + 1,
        // item.vehicleUuid ?? "N/A",
        item.vehicleNumber ?? "N/A",
        item.corporationName ?? "N/A",
        item.categoryName ?? "N/A",
        item.zoneName ?? "N/A",
        item.circleName ?? "N/A",
        item.wardName ?? "N/A",
        item.vehicleTypeName ?? "N/A",
        item.ownerTypeName ?? "N/A",
        item.shiftName ?? "N/A",
        item.driverName ?? "N/A",
        item.beforeDateTime ?? "N/A",
        item.afterDateTime ?? "N/A",
        item.collectionPointCode ?? "N/A",
        item.collectionPointName ?? "N/A",
        item.collectionPointType ?? "N/A",
        item.beforeLatitude ?? "N/A",
        item.afterLatitude ?? "N/A",
        item.beforeLongitude ?? "N/A",
        item.afterLongitude ?? "N/A",
        //item.beforeAddress ?? "N/A",
       // item.afterAddress ?? "N/A",
      ]).eachCell({ includeEmpty: true }, (cell, colNumber) => {
        if (colNumber >= 1 && colNumber <= 25) {
          cell.alignment = { horizontal: "left", vertical: "middle", wrapText: true };
        } else {
          cell.alignment = { horizontal: "center", vertical: "middle", wrapText: true };
        }
      });
    });

    // Set column widths dynamically based on content
    worksheet.columns = [
      { width: 5 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 100 },
      { width: 100 },
    ];

    // Save the workbook to a file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "SecondaryCollectionTransaction.xlsx";
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <>
    
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
            <h4 className="text-start mb-3">
              {t("Secondary Collection Transaction")} ({formatDateForDisplay(startDate)} to {formatDateForDisplay(endDate)}) - (at {getCurrentDateTime1()})
            </h4>

            <div className="card">
              <div className="card-body p-3">
                <form onSubmit={handleFormSubmit}>
                  <div className="row align-items-end">
                    <div className="col-md-12">
                      <div className="row" style={{ textAlign: "left" }}>
                        <div className="col-md-3">
                          <label>From Date & Time</label>
                          <input
                            type="datetime-local"
                            name="FromDate"
                            style={inputStyle}
                            value={startDate}
                            className="form-control"
                            min={getOneMonthPastDateTime()}
                            max={getNowDateTime()}
                            onChange={(e) => setStartDate(e.target.value)}
                          />
                        </div>
                        <div className="col-md-3">
                          <label>To Date & Time</label>
                          <input
                            type="datetime-local"
                            name="ToDate"
                            style={inputStyle}
                            className="form-control"
                            value={endDate}
                            min={startDate}
                            max={getCurrentDateTime()}
                            onChange={(e) => setEndDate(e.target.value)}
                          />
                        </div>
                        <div className="col-md-3">
                          <label>Collection Point Name</label>
                          <input
                            type="text"
                            name="collectionPointName"
                            style={inputStyle}
                            placeholder="Collection Point Name"
                            className="form-control"
                            value={collectionPointName}
                            onChange={(e) => setCollectionPointName(e.target.value.trim())}
                          />
                        </div>
                        <div className="col-md-3">
                          <label>Vehicle Number</label>
                          <input
                            type="text"
                            name="vehicleTypeCode"
                            style={inputStyle}
                            placeholder="Vehicle Number"
                            className="form-control"
                            value={vehicleNumber}
                            onChange={(e) => {
                              setVehicleNumber(e.target.value.replace(/\s+/g, ""));
                            }}
                          />
                        </div>
                        <div className="col-md-3">
                          <label htmlFor="ZoneId">Zone</label>
                          <select
                            name="ZoneId"
                            className="form-select"
                            value={zoneId}
                            onChange={(e) => setZoneId(e.target.value)}
                          >
                            <option value="">Select</option>
                            {allZones &&
                              allZones
                                ?.filter((zone) => zone.isActive)
                                .map((zone) => (
                                  <option key={zone.zoneId} value={zone.zoneId}>
                                    {zone.zoneName}
                                  </option>
                                ))}
                          </select>
                        </div>
                        <div className="col-md-9">
                          <div className="d-flex justify-content-between align-items-end">
                            <button
                              type="submit"
                              className={`btn mt-4 ${isProd ? "search-ghmc" : "search-swm"}`}
                            >
                              Search
                            </button>
                            <div className="d-flex justify-content-end">
                            <button className="btn btn-excel mt-4" onClick={downloadAsExcel}>
                              <i className="fa-solid fa-file-excel me-1 icon-container"></i> Excel
                            </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </form>

                <div className="mt-3">
                          {isLoading ? (
                            <TableSkeleton />
                          ) : (
                            <TableComponent
                              DataFetchURL={getAllTripsTonnage}
                              headers={headers}
                              imgField={["beforeImage", "afterImage"]}
                            />
                          )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

// Function to get the start of the current date (00:00 AM)
const getStartOfCurrentDate = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}T00:00`;
};

// Function to get current date and time in the required format
const getCurrentDateTime = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  const hour = String(now.getHours()).padStart(2, "0");
  const minute = String(now.getMinutes()).padStart(2, "0");
  return `${year}-${month}-${day}T${hour}:${minute}`;
};

// Styles for input and button
const inputStyle = {
  border: "1px solid #E2E2E2",
  padding: "15px",
};

const buttonStyle = {
  border: "1px solid #E2E2E2",
  borderRadius: "5px",
  color: "#fff",
};

export default withTranslation()(SecondaryCollectionTransaction);